import { Typography } from "@shared/ui/Typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Accordion } from "@shared/ui/Accordion";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import { IFaq } from "@shared/types";

interface IProps {
  faqs: IFaq[];
}

export default function ProductFaq(props: IProps) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<false | number>(0);

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.2 }}
    >
      <StyledTitle tag="h2" fontSize="4rem" weight={700}>
        {t(`FAQ`)}
      </StyledTitle>
      <StyledAccordions>
        {props.faqs.map((item) => (
          <Accordion
            key={item.id}
            question={item.question}
            answer={item.answer}
            expandedId={item.id}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </StyledAccordions>
    </motion.div>
  );
}

const StyledTitle = styled(Typography)`
  margin-bottom: 4rem;
`;

const StyledAccordions = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 0.8rem;
`;
